// extracted by mini-css-extract-plugin
export default {"urlToCopy":"Refer-urlToCopy_k3n0O"};